(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.classList.contains('scroll-story-enabled')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pageType = body.getAttribute('data-scroll-story-page') || '';
  var duration = parseInt(body.getAttribute('data-scroll-story-duration'), 10) || 680;
  var distance = parseInt(body.getAttribute('data-scroll-story-distance'), 10) || 28;
  var blur = parseInt(body.getAttribute('data-scroll-story-blur'), 10);
  var lastScrollY = window.pageYOffset || 0;
  var direction = 'down';
  var rafPending = false;
  var observer;

  body.style.setProperty('--scroll-story-duration', duration + 'ms');
  body.style.setProperty('--scroll-story-distance', distance + 'px');
  body.style.setProperty('--scroll-story-blur', (isNaN(blur) ? 3 : blur) + 'px');

  function candidates(root) {
    if (pageType === 'index') {
      return root.querySelectorAll('#main > .shopify-section');
    }

    if (pageType === 'product') {
      return root.querySelectorAll('#main .product-block-list__item, #main > .shopify-section:not(:first-child)');
    }

    if (pageType === 'policy') {
      var policyItems = root.querySelectorAll('#main .shopify-policy__title, #main .shopify-policy__body .rte > *');
      if (!policyItems.length) policyItems = root.querySelectorAll('#main .shopify-policy__body > *');
      return policyItems.length ? policyItems : root.querySelectorAll('#main > *');
    }

    return [];
  }

  function setDirection() {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      var currentY = window.pageYOffset || 0;
      if (Math.abs(currentY - lastScrollY) > 3) {
        direction = currentY > lastScrollY ? 'down' : 'up';
        body.setAttribute('data-scroll-direction', direction);
        lastScrollY = currentY;
      }
      rafPending = false;
    });
  }

  function prepare(item, index) {
    if (item.classList.contains('scroll-story__item')) return;
    item.classList.add('scroll-story__item');
    item.style.setProperty('--scroll-story-delay', Math.min(index % 4 * 55, 165) + 'ms');

    var rect = item.getBoundingClientRect();
    if (rect.bottom < 0) item.classList.add('scroll-story__item--above');
    if (reduceMotion || (rect.top < window.innerHeight * .88 && rect.bottom > 0)) {
      item.classList.add('scroll-story__item--visible');
    }
    if (observer) observer.observe(item);
  }

  function observe(root) {
    Array.prototype.forEach.call(candidates(root || document), prepare);
  }

  if ('IntersectionObserver' in window && !reduceMotion) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = entry.target;
        var rect = entry.boundingClientRect;

        if (entry.isIntersecting) {
          item.classList.toggle('scroll-story__item--above', direction === 'up');
          window.requestAnimationFrame(function () {
            item.classList.add('scroll-story__item--visible');
          });
        } else if (rect.bottom <= 0) {
          item.classList.remove('scroll-story__item--visible');
          item.classList.add('scroll-story__item--above');
        } else if (rect.top >= window.innerHeight) {
          item.classList.remove('scroll-story__item--visible', 'scroll-story__item--above');
        }
      });
    }, { rootMargin: '-7% 0px -10% 0px', threshold: [0, .12] });
  }

  observe(document);
  window.addEventListener('scroll', setDirection, { passive: true });
  document.addEventListener('shopify:section:load', function () { observe(document); });
})();
